import React from "react";
import { ResizeWithPrecisionSection } from "./ResizeWithPrecisionSection";
import JpgResizerUseCase from "./JpgResizerUseCase";
import JpgResizerFaq from "./JpgResizerFaq";

const JpgResizerPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <ResizeWithPrecisionSection />
                <JpgResizerUseCase />
                <JpgResizerFaq />
            </div>
        </div>
    );
};

export default JpgResizerPreToolsArea;
